var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpisodeExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Expired Episode") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Expired-Episode",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Expired-Episode-1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7295484,21.2903226 L4.27045161,21.2903226 C3.40954839,21.2903226 2.70967742,20.5904516 2.70967742,19.7295484 L2.70967742,4.27045161 C2.70967742,3.40954839 3.40954839,2.70967742 4.27045161,2.70967742 L19.7303226,2.70967742 C20.5904516,2.70967742 21.2903226,3.40954839 21.2903226,4.27045161 L21.2903226,19.7303226 C21.2903226,20.5904516 20.5904516,21.2903226 19.7295484,21.2903226 Z M4.27045161,3.48387097 C3.83690323,3.48387097 3.48387097,3.83690323 3.48387097,4.27045161 L3.48387097,19.7303226 C3.48387097,20.1630968 3.83690323,20.516129 4.27045161,20.516129 L19.7303226,20.516129 C20.1630968,20.516129 20.516129,20.1630968 20.516129,19.7295484 L20.516129,4.27045161 C20.516129,3.83690323 20.1630968,3.48387097 19.7295484,3.48387097 L4.27045161,3.48387097 Z",
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12903226,7.74193548 L6.58064516,7.74193548 C6.36696774,7.74193548 6.19354839,7.56851613 6.19354839,7.35483871 C6.19354839,7.14116129 6.36696774,6.96774194 6.58064516,6.96774194 L8.12903226,6.96774194 C8.34270968,6.96774194 8.51612903,7.14116129 8.51612903,7.35483871 C8.51612903,7.56851613 8.34270968,7.74193548 8.12903226,7.74193548 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12903226,10.8387097 L6.58064516,10.8387097 C6.36696774,10.8387097 6.19354839,10.6652903 6.19354839,10.4516129 C6.19354839,10.2379355 6.36696774,10.0645161 6.58064516,10.0645161 L8.12903226,10.0645161 C8.34270968,10.0645161 8.51612903,10.2379355 8.51612903,10.4516129 C8.51612903,10.6652903 8.34270968,10.8387097 8.12903226,10.8387097 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12903226,13.9354839 L6.58064516,13.9354839 C6.36696774,13.9354839 6.19354839,13.7620645 6.19354839,13.5483871 C6.19354839,13.3347097 6.36696774,13.1612903 6.58064516,13.1612903 L8.12903226,13.1612903 C8.34270968,13.1612903 8.51612903,13.3347097 8.51612903,13.5483871 C8.51612903,13.7620645 8.34270968,13.9354839 8.12903226,13.9354839 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12903226,17.0322581 L6.58064516,17.0322581 C6.36696774,17.0322581 6.19354839,16.8588387 6.19354839,16.6451613 C6.19354839,16.4314839 6.36696774,16.2580645 6.58064516,16.2580645 L8.12903226,16.2580645 C8.34270968,16.2580645 8.51612903,16.4314839 8.51612903,16.6451613 C8.51612903,16.8588387 8.34270968,17.0322581 8.12903226,17.0322581 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4193548,7.74193548 L11.2258065,7.74193548 C11.012129,7.74193548 10.8387097,7.56851613 10.8387097,7.35483871 C10.8387097,7.14116129 11.012129,6.96774194 11.2258065,6.96774194 L17.4193548,6.96774194 C17.6330323,6.96774194 17.8064516,7.14116129 17.8064516,7.35483871 C17.8064516,7.56851613 17.6330323,7.74193548 17.4193548,7.74193548 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4193548,10.8387097 L11.2258065,10.8387097 C11.012129,10.8387097 10.8387097,10.6652903 10.8387097,10.4516129 C10.8387097,10.2379355 11.012129,10.0645161 11.2258065,10.0645161 L17.4193548,10.0645161 C17.6330323,10.0645161 17.8064516,10.2379355 17.8064516,10.4516129 C17.8064516,10.6652903 17.6330323,10.8387097 17.4193548,10.8387097 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1401806,22.0644387 C19.8597677,22.0644387 22.0644387,19.8597677 22.0644387,17.1401806 C22.0644387,14.4205161 19.8597677,12.2158452 17.1401806,12.2158452 C14.4205161,12.2158452 12.2158452,14.4205161 12.2158452,17.1401806 C12.2158452,19.8597677 14.4205161,22.0644387 17.1401806,22.0644387 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1401806,23.6128258 C20.7149419,23.6128258 23.6128258,20.7149419 23.6128258,17.1401806 C23.6128258,13.5654194 20.7149419,10.6674581 17.1401806,10.6674581 C13.5654194,10.6674581 10.6674581,13.5654194 10.6674581,17.1401806 C10.6674581,20.7149419 13.5654194,23.6128258 17.1401806,23.6128258 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "16.9539871 14.7599226 16.9539871 17.5484903 19.7424774 17.5484903"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpisodeExpired);
export default __webpack_public_path__ + "static/media/episode-expired.dc60def520ee446b6bd5529cf3953df2.svg";
export { ForwardRef as ReactComponent };